(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection-banner"]) return;
  try {
    
  (function () {
    function initReadMore(root) {
      var body = root.querySelector('[data-collection-readmore-body]');
      var toggle = root.querySelector('[data-collection-readmore-toggle]');
      if (!body || !toggle) return;

      var more = toggle.querySelector('[data-readmore-more]');
      var less = toggle.querySelector('[data-readmore-less]');

      function measure() {
        body.classList.add('is-clamped');
        var overflowing = body.scrollHeight - body.clientHeight > 1;
        if (overflowing) {
          toggle.hidden = false;
        } else {
          toggle.hidden = true;
          body.classList.remove('is-clamped');
        }
      }

      toggle.addEventListener('click', function () {
        var expanded = toggle.getAttribute('aria-expanded') === 'true';
        toggle.setAttribute('aria-expanded', String(!expanded));
        body.classList.toggle('is-clamped', expanded);
        if (more) more.hidden = !expanded;
        if (less) less.hidden = expanded;
      });

      measure();
      window.addEventListener('resize', measure);
    }

    document.querySelectorAll('.collection-hero__description').forEach(initReadMore);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid"]) return;
  try {
    
  class FiltersToggle extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('button');
      if (!this.button) return;

      const collection = this.closest('.collection');
      this.content = collection ? collection.querySelector('.collection__content') : null;
      this.hideLabel = this.querySelector('[data-toggle-hide]');
      this.showLabel = this.querySelector('[data-toggle-show]');
      this.storageKey = 'eureka:plp-filters-collapsed';

      const stored = localStorage.getItem(this.storageKey);
      if (stored === '1') this.setCollapsed(true, false);
      else if (stored === '0') this.setCollapsed(false, false);

      this.button.addEventListener('click', () => {
        const collapsed = !!(this.content && this.content.classList.contains('is-filters-collapsed'));
        this.setCollapsed(!collapsed, true);
      });
    }

    setCollapsed(collapsed, persist) {
      if (this.content) this.content.classList.toggle('is-filters-collapsed', collapsed);
      this.button.setAttribute('aria-pressed', String(!collapsed));
      if (this.hideLabel) this.hideLabel.hidden = collapsed;
      if (this.showLabel) this.showLabel.hidden = !collapsed;
      if (persist) localStorage.setItem(this.storageKey, collapsed ? '1' : '0');
    }
  }

  if (!customElements.get('filters-toggle')) {
    customElements.define('filters-toggle', FiltersToggle);
  }

  // Publishes the sticky filter bar's height as --filter-bar-height so the
  // facet rail can park BELOW it instead of underneath it (QA 2026-08-13).
  //
  // Both are .sticky-element. The bar pins at --sticky-offset: 0, the rail at
  // the 2rem default, so once the page scrolled the rail's top sat ABOVE the
  // bar's bottom edge and the first filter group was cut off behind it. The
  // header was already accounted for -- body.header-pinned adds --header-height
  // -- but nothing accounted for the bar.
  //
  // Measured rather than hard-coded: the row is content-sized (padding + text,
  // and it wraps at narrow widths), so there is no fixed value to reference.
  // Matches how header.js publishes --header-height and sticky-atc-bar.js
  // publishes --sticky-atc-bar-height.
  //
  // Selector requires .sticky-element: when filter_bar_sticky is off the bar
  // scrolls away normally and the rail must NOT reserve space for it, so the
  // variable correctly resolves to 0px.
  (() => {
    const SELECTOR = '.collection__toolbar-row.sticky-element';

    const publish = () => {
      const row = document.querySelector(SELECTOR);
      document.documentElement.style.setProperty(
        '--filter-bar-height',
        row ? Math.round(row.getBoundingClientRect().height) + 'px' : '0px'
      );
    };

    const start = () => {
      publish();
      const row = document.querySelector(SELECTOR);
      if (row && 'ResizeObserver' in window) {
        new ResizeObserver(publish).observe(row);
      } else {
        window.addEventListener('resize', publish);
      }
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start);
    } else {
      start();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-specs"] && !Shopify.designMode) return;
  try {
    
  class ProductSpecsTabs extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
      this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));
      this.tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => this.select(index));
        tab.addEventListener('keydown', (event) => this.onKeydown(event, index));
      });
    }

    select(index) {
      this.tabs.forEach((tab, i) => {
        const selected = i === index;
        tab.setAttribute('aria-selected', selected ? 'true' : 'false');
        tab.setAttribute('tabindex', selected ? '0' : '-1');
        if (this.panels[i]) this.panels[i].hidden = !selected;
      });
    }

    onKeydown(event, index) {
      const last = this.tabs.length - 1;
      let next = null;
      if (event.key === 'ArrowRight' || event.key === 'ArrowDown') next = index === last ? 0 : index + 1;
      else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') next = index === 0 ? last : index - 1;
      else if (event.key === 'Home') next = 0;
      else if (event.key === 'End') next = last;
      if (next === null) return;
      event.preventDefault();
      this.select(next);
      this.tabs[next].focus();
    }
  }

  if (!customElements.get('product-specs-tabs')) {
    customElements.define('product-specs-tabs', ProductSpecsTabs);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('related-products-tabs')) {
    customElements.define(
      'related-products-tabs',
      class RelatedProductsTabs extends HTMLElement {
        connectedCallback() {
          this.tabs = Array.from(this.querySelectorAll('[data-tab]'));
          this.tabs.forEach((tab) => tab.addEventListener('click', () => this.activate(tab.dataset.tab)));
        }

        activate(name) {
          this.tabs.forEach((tab) => {
            const active = tab.dataset.tab === name;
            tab.classList.toggle('is-active', active);
            tab.setAttribute('aria-selected', active ? 'true' : 'false');
          });
          this.querySelectorAll('[data-tab-panel]').forEach((panel) => {
            panel.hidden = panel.dataset.tabPanel !== name;
          });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["seo-copy"] && !Shopify.designMode) return;
  try {
    
  class SeoCopyDisclosure extends HTMLElement {
    connectedCallback() {
      if (this.dataset.disabled === 'true') return;

      this.body = this.querySelector('.seo-copy__body');
      this.toggle = this.querySelector('.seo-copy__toggle');
      if (!this.body || !this.toggle) return;

      this.label = this.toggle.querySelector('.seo-copy__toggle-label');
      this.collapsedHeight = parseInt(this.dataset.collapsedHeight, 10) || 0;

      if (this.body.scrollHeight <= this.collapsedHeight + 8) return;

      this.classList.add('seo-copy--has-toggle');
      this.collapse();
      this.toggle.hidden = false;

      this.toggle.addEventListener('click', () => {
        if (this.classList.contains('is-collapsed')) {
          this.expand();
        } else {
          this.collapse();
        }
      });
    }

    collapse() {
      this.classList.add('is-collapsed');
      this.toggle.setAttribute('aria-expanded', 'false');
      if (this.label && this.toggle.dataset.labelMore) {
        this.label.textContent = this.toggle.dataset.labelMore;
      }
    }

    expand() {
      this.classList.remove('is-collapsed');
      this.body.style.maxHeight = this.body.scrollHeight + 'px';
      this.toggle.setAttribute('aria-expanded', 'true');
      if (this.label && this.toggle.dataset.labelLess) {
        this.label.textContent = this.toggle.dataset.labelLess;
      }
    }
  }

  if (!customElements.get('seo-copy-disclosure')) {
    customElements.define('seo-copy-disclosure', SeoCopyDisclosure);
  }

  } catch(e) { console.error(e); }
})();
})();
